import { FaEye, FaPencilAlt } from "react-icons/fa";

const ShimmerList = ({ index, }) => {

    return (
        <>
            <div key={index} style={{ position: "relative" }} className="col-12 d-flex justify-content-between p-1 mb-1 bg-white rounded shadow-sm border">
                <div className="col d-flex">
                    <div className="shine" style={{ height: "auto", width: "15vh", borderRadius: 5 }} ></div>
                    <div className="ms-1">
                        <div className="shine mb-0" style={{ height: "2vh", width: "80%", borderRadius: 5 }} ></div>
                        <div className="shine mb-0" style={{ height: "1.5vh", width: "50%", borderRadius: 5 }} ></div>
                        <div className="shine mb-0" style={{ height: "5vh", width: "200%", borderRadius: 5 }} ></div>
                        <div className="d-flex mt-1">
                            <div className="shine mb-0 me-1" style={{ height: "2vh", width: "3vh", borderRadius: 5 }} ></div>
                            <div className="shine mb-0 me-1" style={{ height: "2vh", width: "3vh", borderRadius: 5 }} ></div>
                            <div className="shine mb-0 me-1" style={{ height: "2vh", width: "3vh", borderRadius: 5 }} ></div>
                        </div>
                    </div>
                </div>

                <div className="d-flex" style={{ position: "absolute", top: 10, right: 20 }}>
                    <ActionButton background="" className='shine'>
                        <FaEye size={16} color="#fff" />
                    </ActionButton>
                    <ActionButton background="" className="ms-1 shine">
                        <FaPencilAlt size={16} color="#fff" />
                    </ActionButton>
                </div>

            </div>
        </>
    );
}

export default ShimmerList;

const ActionButton = ({ children, background, className, onClick }) => {
    return (
        <div onClick={onClick} className={`cursor-pointer d-flex justify-content-center align-items-center p-1 ${className}`} style={{ height: 30, width: 30, borderRadius: 15, background }}>
            {children}
        </div>
    );
}